<template>
  <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
  >
    <template v-slot:activator="{on}">
      <slot name="activator" :show="show" :on="on"></slot>
    </template>
    <v-list class="pt-0">
      <v-toolbar class="pt-0" flat>
        <div class="subtitle font-weight-bold">Printer Select</div>
        <v-spacer></v-spacer>
        <v-btn icon><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "LabelPrinterContextMenu",
  components: {},
  data: () => ({
    showMenu: false,
    x: 0,
    y: 0,
  }),
  props: {
    label: {
      required: true,
    }
  },
  methods:{
    show (e) {
      if(!this.item)return;
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
  }
}
</script>

<style scoped>

</style>
